STUD_MAPS = {
    // rgb: {
    //     name: "RGB",
    //     officialName: "RGB Example",
    //     sortedStuds: ["#ff6666", "#66ff66", "#6666ff"],
    //     studMap: {
    //         "#ff6666": 1000,
    //         "#66ff66": 1000,
    //         "#6666ff": 1000
    //     }
    // },
    art_project: {
        name: "Art Project (21226)",
        officialName: "Art Project - Create Together (21226)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/art-project-create-together-21226" target="_blank">Art Project - Create Together (Set #21226)</a>',
        sortedStuds: [
            "#212121",
            "#143044",
            "#3399ff",
            "#ccffff",
            "#ffffff",
            "#ffbbff",
            "#b30006",
            "#ff7e14",
            "#f7ba30",
            "#f7d117",
            "#f3e055",
            "#dec69c",
            "#e3a05b",
            "#89351d",
            "#10cb31",
            "#a6ca55",
        ],
        studMap: {
            "#212121": 254,
            "#143044": 660,
            "#3399ff": 127,
            "#ccffff": 317,
            "#ffffff": 474,
            "#ffbbff": 58,
            "#b30006": 190,
            "#ff7e14": 121,
            "#f7ba30": 175,
            "#f7d117": 299,
            "#f3e055": 119,
            "#dec69c": 241,
            "#e3a05b": 281,
            "#89351d": 307,
            "#10cb31": 148,
            "#a6ca55": 166,
        },
    },
    warhol_marilyn_monroe: {
        name: "Warhol (31197)",
        officialName: "Andy Warhol's Marilyn Monroe (31197)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/andy-warhols-marilyn-monroe-31197" target="_blank">Andy Warhol\'s Marilyn Monroe (Set #31197)</a>',
        sortedStuds: ["#212121", "#595d60", "#42c0fb", "#f7d117", "#ffbbff", "#c87080", "#b52952"],
        studMap: {
            "#212121": 629,
            "#595d60": 131,
            "#42c0fb": 587,
            "#f7d117": 587,
            "#ffbbff": 587,
            "#c87080": 587,
            "#b52952": 46,
        },
    },
    the_beatles: {
        name: "The Beatles (31198)",
        officialName: "The Beatles (31198)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/the-beatles-31198" target="_blank">The Beatles (Set #31198)</a>',
        sortedStuds: [
            "#212121",
            "#595d60",
            "#afb5c7",
            "#ffffff",
            "#143044",
            "#5a7184",
            "#9fc3e9",
            "#ff7e14",
            "#f7ba30",
            "#dec69c",
            "#907450",
            "#e3a05b",
            "#b35408",
            "#89351d",
            "#330000",
        ],
        studMap: {
            "#212121": 698,
            "#595d60": 141,
            "#afb5c7": 51,
            "#ffffff": 149,
            "#143044": 121,
            "#5a7184": 52,
            "#9fc3e9": 57,
            "#ff7e14": 74,
            "#f7ba30": 65,
            "#dec69c": 283,
            "#907450": 137,
            "#e3a05b": 29,
            "#b35408": 85,
            "#89351d": 250,
            "#330000": 554,
        },
    },
    iron_man: {
        name: "Iron Man (31199)",
        officialName: "Marvel Studios Iron Man (31199)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/marvel-studios-iron-man-31199" target="_blank">Marvel Studios Iron Man (Set #31199)</a>',
        sortedStuds: [
            "#212121",
            "#595d60",
            "#afb5c7",
            "#5a7184",
            "#143044",
            "#ffffff",
            "#e79500",
            "#dec69c",
            "#907450",
            "#e3a05b",
            "#b35408",
            "#b30006",
            "#6a0e15",
            "#89351d",
            "#330000",
        ],
        studMap: {
            "#212121": 476,
            "#595d60": 91,
            "#afb5c7": 31,
            "#5a7184": 23,
            "#143044": 529,
            "#ffffff": 61,
            "#e79500": 232,
            "#dec69c": 155,
            "#907450": 97,
            "#e3a05b": 208,
            "#b35408": 162,
            "#b30006": 308,
            "#6a0e15": 214,
            "#89351d": 191,
            "#330000": 196,
        },
    },
    star_wars_sith: {
        name: "Star Wars (31200)",
        officialName: "Star Wars The Sith (31200)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/star-wars-the-sith-31200" target="_blank">Star Wars The Sith (Set #31200)</a>',
        sortedStuds: [
            "#212121",
            "#666660",
            "#595d60",
            "#afb5c7",
            "#5a7184",
            "#143044",
            "#ffffff",
            "#f3e055",
            "#ff7e14",
            "#b30006",
            "#6a0e15",
            "#330000",
        ],
        studMap: {
            "#212121": 877,
            "#666660": 271,
            "#595d60": 151,
            "#afb5c7": 110,
            "#5a7184": 139,
            "#143044": 447,
            "#ffffff": 187,
            "#f3e055": 92,
            "#ff7e14": 125,
            "#b30006": 286,
            "#6a0e15": 328,
            "#330000": 200,
        },
    },
    harry_potter_hogwarts_crests: {
        name: "Harry Potter (31201)",
        officialName: "Harry Potter Hogwarts Crests (31201)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/harry-potter-hogwarts-crests-31201" target="_blank">Harry Potter Hogwarts Crests (Set #31201)</a>',
        sortedStuds: [
            "#212121",
            "#666660",
            "#898788",
            "#afb5c7",
            "#42c0fb",
            "#0057a6",
            "#10cb31",
            "#00642e",
            "#b30006",
            "#6a0e15",
            "#e79500",
            "#ffffff",
        ],
        studMap: {
            "#212121": 593,
            "#666660": 153,
            "#898788": 630,
            "#afb5c7": 236,
            "#42c0fb": 10,
            "#0057a6": 431,
            "#10cb31": 4,
            "#00642e": 499,
            "#b30006": 15,
            "#6a0e15": 503,
            "#e79500": 604,
            "#ffffff": 369,
        },
    },
    mickey_mouse: {
        name: "Mickey Mouse (31202)",
        officialName: "Disney's Mickey Mouse (31202)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/disney-s-mickey-mouse-31202" target="_blank">Disney\'s Mickey Mouse (Set #31202)</a>',
        sortedStuds: [
            "#212121",
            "#595d60",
            "#afb5c7",
            "#143044",
            "#ffffff",
            "#dec69c",
            "#b30006",
            "#6a0e15",
            "#330000",
        ],
        studMap: {
            "#212121": 662,
            "#595d60": 79,
            "#afb5c7": 59,
            "#143044": 409,
            "#ffffff": 835,
            "#dec69c": 32,
            "#b30006": 213,
            "#6a0e15": 96,
            "#330000": 76,
        },
    },
    world_map: {
        name: "World Map (31203)",
        officialName: "World Map (31203)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/world-map-31203" target="_blank">World Map (Set #31203)</a> (both plates and tiles)',
        sortedStuds: [
            "#ffffff",
            "#143044",
            "#42c0fb",
            "#008a80",
            "#10cb31",
            "#a6ca55",
            "#dec69c",
            "#f7ba30",
            "#ff7e14",
            "#f88379",
        ],
        studMap: {
            "#ffffff": 3064,
            "#143044": 393,
            "#42c0fb": 1607,
            "#008a80": 1879,
            "#10cb31": 601,
            "#a6ca55": 1060,
            "#dec69c": 725,
            "#f7ba30": 599,
            "#ff7e14": 601,
            "#f88379": 601,
        },
    },
    elvis: {
        // TODO: Cross check this once the part list is on bricklink
        name: "Elvis (31204)",
        officialName: "Elvis Presley “The King” (31204)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/elvis-presley-the-king-31204" target="_blank">Elvis Presley “The King” (Set #31204)</a>',
        sortedStuds: [
            "#212121",
            "#143044",
            "#61afff",
            "#5a7184",
            "#595d60",
            "#afb5c7",
            "#ffffff",
            "#dec69c",
            "#feccb0",
            "#ffaf7d",
            "#e3a05b",
            "#b35408",
            "#89351d",
            "#330000",
            "#6a0e15",
            "#b30006",
        ],
        studMap: {
            "#212121": 596,
            "#143044": 152,
            "#61afff": 230,
            "#5a7184": 175,
            "#595d60": 52,
            "#afb5c7": 26,
            "#ffffff": 71,
            "#dec69c": 106,
            "#feccb0": 360,
            "#ffaf7d": 258,
            "#e3a05b": 182,
            "#b35408": 179,
            "#89351d": 233,
            "#330000": 206,
            "#6a0e15": 339,
            "#b30006": 80,
        },
    },
    batman: {
        // TODO: Cross check this once the part list is on bricklink
        name: "Batman (31205)",
        officialName: "Jim Lee Batman collection (31205)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/jim-lee-batman-collection-31205" target="_blank">Jim Lee Batman collection (Set #31205)</a>',
        sortedStuds: [
            "#212121",
            "#666660",
            "#595d60",
            "#afb5c7",
            "#ffffff",
            "#ccffff",
            "#42c0fb",
            "#0057a6",
            "#143044",
            "#89351d",
            "#b35408",
            "#e3a05b",
            "#dec69c",
            "#10cb31",
            "#885e9e",
            "#b30006",
        ],
        studMap: {
            "#212121": 566,
            "#666660": 432,
            "#595d60": 216,
            "#afb5c7": 277,
            "#ffffff": 257,
            "#ccffff": 194,
            "#42c0fb": 139,
            "#0057a6": 293,
            "#143044": 423,
            "#89351d": 165,
            "#b35408": 55,
            "#e3a05b": 153,
            "#dec69c": 380,
            "#10cb31": 210,
            "#885e9e": 95,
            "#b30006": 112,
        },
    },
    floral_art: {
        name: "Floral Art (31207)",
        officialName: "Floral Art (31207)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/floral-art-31207" target="_blank">Floral Art (Set #31207)</a> (both plates and tiles)',
        sortedStuds: ["#008a80", "#0057a6", "#c87080", "#143044", "#f7ba30", "#feccb0", "#ffbbff", "#ffffff"],
        studMap: {
            "#008a80": 370,
            "#0057a6": 242,
            "#c87080": 370,
            "#143044": 281,
            "#f7ba30": 370,
            "#feccb0": 370,
            "#ffbbff": 158,
            "#ffffff": 550,
        },
    },
    // personalized_portrait_6000: {
    //     name: "Personalised Portrait - New 6002 Piece Version (40179)",
    //     officialName:
    //         "Personalised Mosaic Portrait - 6002 Piece Version (40179)",
    //     sortedStuds: ["#212121", "#595d60", "#afb5c7", "#ffffff", "#f7d117"],
    //     studMap: {
    //         "#212121": 1200,
    //         "#595d60": 1200,
    //         "#afb5c7": 1200,
    //         "#ffffff": 1200,
    //         "#f7d117": 1200
    //     }
    // },
    personalized_portrait_4502: {
        name: "Personalised Portrait (40179)",
        officialName: "Personalised Mosaic Portrait (40179)",
        descriptionHTML:
            'Only use pieces available in <a href="https://www.lego.com/en-us/product/mosaic-maker-40179" target="_blank">Personalised Mosaic Portrait (Set #40179)</a>',
        sortedStuds: ["#212121", "#595d60", "#afb5c7", "#ffffff", "#f7d117"],
        studMap: {
            "#212121": 900,
            "#595d60": 900,
            "#afb5c7": 900,
            "#ffffff": 900,
            "#f7d117": 900,
        },
    },
    lots_of_dots_squares: {
        name: "Lots of DOTS (41935) (Square Tiles Only)",
        officialName: "Lots of DOTS (41935) (Square Tiles Only)",
        descriptionHTML:
            'Only use the square tiles available in <a href="https://www.lego.com/en-us/product/lots-of-dots-41935" target="_blank">Lots of DOTS (Set #41935)</a>',
        sortedStuds: [
            "#212121",
            "#0057a6",
            "#10cb31",
            "#f3e055",
            "#f88379",
            "#2e5543",
            "#5f2683",
            "#008a80",
            "#b52952",
            "#42c0fb",
            "#76a290",
            "#ffffff",
            "#f7d117",
        ],
        studMap: {
            "#212121": 20,
            "#0057a6": 30,
            "#10cb31": 20,
            "#f3e055": 20,
            "#f88379": 30,
            "#2e5543": 20,
            "#5f2683": 20,
            "#008a80": 30,
            "#b52952": 20,
            "#42c0fb": 20,
            "#76a290": 20,
            "#ffffff": 20,
            "#f7d117": 30,
        },
    },
    lots_of_dots_round: {
        name: "Lots of DOTS (41935) (Round Tiles Only)",
        officialName: "Lots of DOTS (41935) (Round Tiles Only)",
        descriptionHTML:
            'Only use the round tiles available in <a href="https://www.lego.com/en-us/product/lots-of-dots-41935" target="_blank">Lots of DOTS (Set #41935)</a>',
        sortedStuds: [
            "#0057a6",
            "#f88379",
            "#143044",
            "#008a80",
            "#b18cbf",
            "#ccffff",
            "#ff7e14",
            "#b30006",
            "#f7d117",
        ],
        studMap: {
            "#0057a6": 30,
            "#f88379": 30,
            "#143044": 20,
            "#008a80": 30,
            "#b18cbf": 20,
            "#ccffff": 20,
            "#ff7e14": 20,
            "#b30006": 20,
            "#f7d117": 30,
        },
    },
    pineapple_pencil_holder: {
        name: "Pineapple Pencil Holder (41906) (Round Tiles Only)",
        officialName: "Pineapple Pencil Holder (41906) (Round Tiles Only)",
        descriptionHTML:
            'Only use the round tiles available in <a href="https://www.lego.com/en-us/product/pineapple-pencil-holder-41906" target="_blank">Pineapple Pencil Holder (Set #41906)</a>',
        sortedStuds: ["#212121", "#ffbbff", "#a6ca55", "#ffffff"],
        studMap: {
            "#212121": 2,
            "#ffbbff": 24,
            "#a6ca55": 32,
            "#ffffff": 24,
        },
    },
    cute_banana_pen_holder: {
        name: "Cute Banana Pen Holder (41948) (Round Tiles Only)",
        officialName: "Cute Banana Pen Holder (41948) (Round Tiles Only)",
        descriptionHTML:
            'Only use the round tiles available in <a href="https://www.lego.com/en-us/product/cute-banana-pen-holder-41948" target="_blank">Cute Banana Pen Holder (Set #41948)</a>',
        sortedStuds: ["#b35408", "#ffffff"],
        studMap: {
            "#b35408": 20,
            "#ffffff": 26,
        },
    },
    extra_dots_series_2: {
        name: "Extra DOTS - Series 2 (41916) (Round Tiles Only)",
        officialName: "Extra DOTS - Series 2 (41916) (Round Tiles Only)",
        descriptionHTML:
            'Only use the round tiles available in <a href="https://www.lego.com/en-us/product/extra-dots-series-2-41916" target="_blank">Extra DOTS - Series 2 (Set #41916)</a>',
        sortedStuds: ["#0057a6", "#f88379"],
        studMap: {
            "#0057a6": 19,
            "#f88379": 20,
        },
    },
    extra_dots_series_6: {
        name: "Extra DOTS - Series 6 (41946) (Round Tiles Only)",
        officialName: "Extra DOTS - Series 6 (41946) (Round Tiles Only)",
        descriptionHTML:
            'Only use the round tiles available in <a href="https://www.lego.com/en-us/product/extra-dots-series-6-41946" target="_blank">Extra DOTS - Series 6 (Set #41946)</a>',
        sortedStuds: ["#c87080", "#dfeea5"],
        studMap: {
            "#c87080": 19,
            "#dfeea5": 19,
        },
    },
    extra_dots_series_7: {
        name: "Extra DOTS - Series 7 (41958) (Round Tiles Only)",
        officialName: "Extra DOTS - Series 7 (41958) (Round Tiles Only)",
        descriptionHTML:
            'Only use the round tiles available in <a href="https://www.lego.com/en-us/product/extra-dots-series-7-sport-41958" target="_blank">Extra DOTS - Series 7 (Set #41958)</a>',
        sortedStuds: ["#ccffff", "#fffc00"],
        studMap: {
            "#ccffff": 15,
            "#fffc00": 15,
        },
    },
};

const availableStudHexes = BRICKLINK_STUD_COLORS.map((color) => color.hex);
const studHexToCount = {};
availableStudHexes.forEach((hex) => {
    studHexToCount[hex] = 99999;
});
STUD_MAPS["all_stud_colors"] = {
    name: "All Stud Colors",
    officialName: "All Available Stud Colors",
    descriptionHTML: "All colors in which studs (1x1 round plates) are available",
    sortedStuds: availableStudHexes,
    studMap: studHexToCount,
};

const availableTileHexes = BRICKLINK_TILE_COLORS.map((color) => color.hex);
const tileHexToCount = {};
availableTileHexes.forEach((hex) => {
    tileHexToCount[hex] = 99999;
});
STUD_MAPS["all_tile_colors"] = {
    name: "All Tile Colors",
    officialName: "All Available Tile Colors",
    descriptionHTML: "All colors in which 1x1 round tiles are available",
    sortedStuds: availableTileHexes,
    studMap: tileHexToCount,
};

const availableSolidHexes = ALL_BRICKLINK_SOLID_COLORS.map((color) => color.hex);
const solidHexToCount = {};
availableSolidHexes.forEach((hex) => {
    solidHexToCount[hex] = 99999;
});
STUD_MAPS["all_solid_colors"] = {
    name: "All Supported Colors",
    officialName: "All Supported Colors",
    descriptionHTML: "All colors supported by the application",
    sortedStuds: availableSolidHexes,
    studMap: solidHexToCount,
};

const availablePickABrickStudHexes = [
    "#ff7e14",
    "#0057a6",
    "#afb5c7",
    "#595d60",
    "#ffffff",
    "#a6ca55",
    "#10cb31",
    "#f7d117",
    "#b30006",
    "#5f2683",
    "#89351d",
    "#dec69c",
    "#ffbbff",
];
const pickABricStudkHexToCount = {};
availablePickABrickStudHexes.forEach((hex) => {
    pickABricStudkHexToCount[hex] = 99999;
});
STUD_MAPS["pick_a_brick"] = {
    name: "All Pick a Brick Stud Colors",
    officialName: "Lego.com Pick a Brick",
    descriptionHTML:
        'All colors in which studs are available on the <a href="https://www.lego.com/en-us/page/static/pick-a-brick" target="_blank">Lego.com pick a brick page</a>',
    sortedStuds: availablePickABrickStudHexes,
    studMap: pickABricStudkHexToCount,
};
